<template>
  <div class="hotKey" @click="cancelEdit">
    <div v-if="groupsVisible" class="group-ctn">
      <hotKeyGroup v-for="group in groups" :key=group.id :group="group" @editing="editingHandler" @refresh="refreshHandler" />
    </div>

    <div class="ctrl-ctn">
      <div class="ctrl-left"></div>
      <div class="ctrl-right">
        <el-button @click="resetHandler" size="mini">重 置</el-button>
        <el-button @click="refreshHandler" size="mini" :id="focusID">刷 新</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import hotKeyGroup from './hotKeyGroup.vue'

export default {
  name: "hotKey",
  components: {
    hotKeyGroup,
  },
  props: [
      "focusID",
  ],
  data() {
    return {
      activeName: "hotKey",
      groups: this.utils.hotKey.GlobalHotKey.getGroupList(),
      groupsVisible: true,
    }
  },
  methods: {
    editingHandler: function(isEditing) {
      // console.log("hotKey editing")
      this.$emit("editing", isEditing)
    },
    resetHandler() {
      console.log("reset hotkey")
      let self = this
      this.utils.hotKey.reset((error, data, response) => {
        if (error) {
          self.api.errHandler(self, error, response)
          return
        }
        self.$message.success("重置快捷键成功")
        self.refreshView()
      })
    },
    refreshHandler() {
      console.log("refreshHandler")

      let self = this
      this.utils.hotKey.reload((error, data, response) => {self.api.errHandler(self, error, response)}, () => { self.refreshView() })
    },
    refreshView() {
      console.log("refreshView")
      this.groups = this.utils.hotKey.GlobalHotKey.getGroupList()
    },
    cancelEdit() {
      console.log("cancelEdit")
      this.env.ui.editingHotKeyCancel()
    },
  },
}
</script>

<style scoped>
.group-ctn {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.ctrl-ctn {
  margin-top: 1em;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.ctrl-left {

}
.ctrl-right {

}
</style>
